import { render } from "./MP3viewer.vue?vue&type=template&id=71bb7d87&scoped=true&ts=true"
import script from "./MP3viewer.vue?vue&type=script&lang=ts"
export * from "./MP3viewer.vue?vue&type=script&lang=ts"

import "./MP3viewer.vue?vue&type=style&index=0&id=71bb7d87&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bb7d87"]])

export default __exports__